export default __webpack_public_path__ + "static/media/FieldOfTheDeadEntrance.6a1aa0e3.jpg";